export class AuthorModel {
  id: string;
  name: string;
  nickname: string;
  email: string;

  constructor({
    id,
    name,
    nickname,
    email
  }: {
    id: string;
    name: string;
    nickname: string;
    email: string;
  }) {
    this.id = id;
    this.name = name;
    this.nickname = nickname;
    this.email = email;
  }
}
